import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-366eebbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title fw-bold" }
const _hoisted_4 = { class: "card-body pt-2 overflow-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_6 = {
  class: "d-flex align-items-center gap-1 text-truncate",
  style: {"flex":"1 1 auto","min-width":"0"}
}
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right fs-9" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "trf-bar d-none d-sm-block flex-shrink-0" }
const _hoisted_12 = {
  class: "text-gray-700 fw-bold fs-7 text-end flex-shrink-0",
  style: {"width":"42px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(`bi ${_ctx.icon} text-${_ctx.color} me-2`)
        }, null, 2),
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.buckets || !_ctx.buckets.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Sem dados na janela."))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBuckets, (b) => {
        return (_openBlock(), _createElementBlock("div", {
          key: b.key,
          class: "d-flex align-items-center mb-3 gap-2"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              href: "#",
              class: "text-gray-900 text-hover-primary fw-semibold text-truncate",
              title: `Filtrar o feed por ${b.key}`,
              onClick: _withModifiers(($event: any) => (_ctx.$emit('filter', _ctx.field, b.key)), ["prevent"])
            }, _toDisplayString(b.key), 9, _hoisted_7),
            (_ctx.external(b.key))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.external(b.key) || undefined,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "text-muted flex-shrink-0",
                  title: "Abrir referência externa (NVD / MITRE)"
                }, _hoisted_10, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "trf-bar-fill",
              style: _normalizeStyle({ width: _ctx.pct(b.count) + '%' })
            }, null, 4)
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(b.count), 1)
        ]))
      }), 128))
    ])
  ]))
}